<template>
    <div>
        <div class="mask" v-show="visible" @click="close"></div>
        <div class="dialog" v-show="visible">
            <div class="dialog-body">
                <div v-if="detail.right === detail.total">
                    <img src="./../assets/2024/rank-1-bg.png" class="rank-bg" alt="">
                    <div class="result">
                        <p class="result-fraction">{{ detail['fraction'] }}<span>分</span></p>
                        <div>
                            <img src="./../assets/2024/medal.png" class="level-img" alt="">
                        </div>
                        <p class="result-descript">大神，太牛啦！<br />获得“至尊王者”证书，学无止境！</p>
                        <div class="result-subject">
                            <div>
                                <p class="result-subject--value">{{ detail['right'] }}/{{ detail['total'] }}</p>
                                <p class="result-subject--name">答对题数</p>
                            </div>
                            <div>
                                <p class="result-subject--value">{{ detail['time'] }}</p>
                                <p class="result-subject--name">用时</p>
                            </div>
                        </div>
                        <p class="result-code" v-show="detail['address']"><img src="./../assets/location-black.png" style="width: 12px !important;height: auto;" alt="">{{ detail['address'] }}</p>
                        <p class="result-code">反邪教知识学习结业证书编号: DT{{ detail['id'].padStart(8, '00000000') }}</p>
                    </div>
                </div>
                <div v-else-if="detail.fraction >= 60">
                    <img src="./../assets/2024/rank-2-bg.png" class="rank-bg" alt="">
                    <div class="result">
                        <p class="result-fraction">{{ detail['fraction'] }}<span>分</span></p>
                        <div>
                            <img src="./../assets/2024/medal.png" class="level-img" alt="">
                        </div>
                        <p class="result-descript">斗士，恭喜您！<br />获得“精英斗士”证书，精益求精！</p>
                        <div class="result-subject">
                            <div>
                                <p class="result-subject--value">{{ detail['right'] }}/{{ detail['total'] }}</p>
                                <p class="result-subject--name">答对题数</p>
                            </div>
                            <div>
                                <p class="result-subject--value">{{ detail['time'] }}</p>
                                <p class="result-subject--name">用时</p>
                            </div>
                        </div>
                        <p class="result-code" v-show="detail['address']"><img src="./../assets/location-black.png" style="width: 12px !important;height: auto;" alt="">{{ detail['address'] }}</p>
                        <p class="result-code">反邪教知识学习结业证书编号: DT{{ detail['id'].padStart(8, '00000000') }}</p>
                    </div>
                </div>
                <div v-else-if="detail.fraction >= 0">
                    <img src="./../assets/2024/rank-3-bg.png" class="rank-bg" alt="">
                    <div class="result">
                        <p class="result-fraction">{{ detail['fraction'] }}<span>分</span></p>
                        <div>
                            <img src="./../assets/2024/medal.png" class="level-img" alt="">
                        </div>
                        <p class="result-descript">侠客，继续努力吧~<br />授予“萌新游侠”证书，以资鼓励！</p>
                        <div class="result-subject">
                            <div>
                                <p class="result-subject--value">{{ detail['right'] }}/{{ detail['total'] }}</p>
                                <p class="result-subject--name">答对题数</p>
                            </div>
                            <div>
                                <p class="result-subject--value">{{ detail['time'] }}</p>
                                <p class="result-subject--name">用时</p>
                            </div>
                        </div>
                        <p class="result-code" v-show="detail['address']"><img src="./../assets/location-black.png" style="width: 12px !important;height: auto;" alt="">{{ detail['address'] }}</p>
                        <p class="result-code">反邪教知识学习结业证书编号: DT{{ detail['id'].padStart(8, '00000000') }}</p>
                    </div>
                </div>
            </div>
            <div class="dialog-footer">
                <button @click="close">关闭</button>
                <button @click="goToRank" class="btn-yellow">查看我的签名勋章</button>
            </div>
        </div>
    </div>
</template>
<script>
/*
* 答题结果dialog
*/
export default {
    name: 'ExamResult',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        rank: {
            type: String,
        },
        result: {
            type: Object,
            default () {
                return {}
            }
        },
    },
    data() {
        return {
            visible: false,
            rankIndex: null,
            detail: {},
        }
    },
    watch: {
        show: {
            handler(newValue, oldValue) {
                console.log(newValue, oldValue)
                if (newValue) {
                    document.body.classList.add('no-scroll')
                    this.rankIndex = this.rank
                    this.detail = this.result
                    console.log(this.rankIndex, this.detail)
                } else {
                    document.body.classList.remove('no-scroll')
                }
                this.visible = newValue
            },
            deep: true,
        }
    },
    mounted() {
        this.visible = this.show
        this.rankIndex = this.rank
        this.detail = this.result
    },
    methods: {
        close() {
            this.visible = false
            this.$emit('close')
        },
        goToRank() {
            this.visible = false
            this.$router.replace({
                path: '/success',
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.mask {
    animation-duration: 0.3s;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
}
.dialog {
    position: fixed;
    max-height: 100%;
    overflow-y: auto;
    transition: transform .3s;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .dialog-body {
        position: relative;
        .level-img {
            width: 22vw;
            margin-top: -4vh;
        }
        .rank-bg {
            width:84vw;
        }
    }
    .dialog-footer {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        button {
            color: #fff;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 50px;
            border: 1px solid #fff;
            min-width: 80px;
            padding: 10px;
            display: inline-block;
            font-size: 16px;
            font-family: PingFangSC-Medium, sans-serif;
            color: #FFFFFF;
            font-weight: 500;

            &.btn-yellow {
                background: linear-gradient(270deg, #FFAC49 0%, #F87200 100%);
                color: #fff;
            }
        }
    }
}
.result {
    position: absolute;
    top: 4vw;
    left: 0;
    right: 0;
    bottom: 8vw;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;

    &-fraction {
        font-weight: bold;
        font-size: 60px;
        color: #FFFFFF;
        text-shadow: 0px 2px 9px rgba(128,84,30,0.5);
        text-align: left;

        span {
            font-size: 12px;
        }
    }

    &-descript {
        color: #333;
        font-weight: 600;
    }

    &-subject {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 70%;

        &--value {
            color: #FF9601;
            font-weight: 600;
        }
        &--name {
            color: #9F9F9F;
        }
    }
    &-code {
        color: #A4A4A4;
        font-size: 12px;
        display: flex;
        align-items: flex-start;
        padding: 0 40px;
        justify-content: center;

        img {
            margin: 2px 2px 0 0;
        }
    }
}
</style>
  